(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evermont-premium-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-evermont-header]').forEach((header) => {
    const desktopDetails = header.querySelectorAll('.evermont-header__nav-details');
    desktopDetails.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        desktopDetails.forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        header.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        header.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
